"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=department.insight.process.js.map